

export default {
  props: {
    items: {
      type: Object,
      required: true,
      default: null
    }
  },
  mounted() {
    if (process.client) {
      window.addEventListener('scroll', this.updateScroll)
    }
  },
  deactivated() {
    window.removeEventListener('scroll', this.updateScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateScroll)
  },
  methods: {
    closeDropdown() {
      setTimeout(() => {
        this.$refs.floatingDropDown.showDropdown();
      }, 100);
    },
    updateScroll() {
      // console.log("scrolling")
      const dropdown = document.querySelector('.flaoting-dropdown')
      // console.log(dropdown)
      dropdown.classList.toggle('fade-in', window.scrollY > 500)
    },
  }
}
